import React, { useState, useEffect } from "react";
import "./KeywordSelectionModal.css";

const KeywordSelectionModal = ({
  isOpen,
  onClose,
  keywordRanks,
  onKeywordRanksChange,
  zoomSettings,
  userIsSpecial = false,
}) => {
  const [localKeywordRanks, setLocalKeywordRanks] = useState([]);

  // keywordRanks가 변경될 때마다 로컬 상태 업데이트
  useEffect(() => {
    setLocalKeywordRanks([...keywordRanks]);
  }, [keywordRanks]);

  // 토글 핸들러
  const handleToggle = (index) => {
    const updatedRanks = [...localKeywordRanks];
    const currentSelected = updatedRanks[index].selected;
    const currentRank = updatedRanks[index].rank;
    const allowRanking = zoomSettings?.allowRanking || 30;
    // 특정 유저는 순위 제한 예외
    const effectiveAllowRanking = userIsSpecial ? Infinity : allowRanking;

    if (currentSelected) {
      // 선택 해제는 항상 가능 (순위와 관계없이)
      updatedRanks[index].selected = false;
    } else {
      // 순위가 allowRanking보다 높으면 선택 불가 (특정 유저는 예외)
      if (currentRank > effectiveAllowRanking) {
        alert(`${allowRanking}위 초과 키워드는 선택할 수 없습니다.`);
        return;
      }

      // 선택하려면 현재 선택된 개수가 10개 미만이어야 함
      const selectedCount = updatedRanks.filter((item) => item.selected).length;
      if (selectedCount < 10) {
        updatedRanks[index].selected = true;
      } else {
        alert("최대 10개까지만 선택할 수 있습니다.");
        return;
      }
    }

    setLocalKeywordRanks(updatedRanks);
  };

  // 확인 버튼 핸들러
  const handleConfirm = () => {
    onKeywordRanksChange(localKeywordRanks);
    onClose();
  };

  // 취소 버튼 핸들러
  const handleCancel = () => {
    setLocalKeywordRanks([...keywordRanks]); // 원래 상태로 복원
    onClose();
  };

  if (!isOpen) return null;

  const selectedCount = localKeywordRanks.filter(
    (item) => item.selected
  ).length;

  return (
    <div className="keyword-selection-modal-overlay">
      <div className="keyword-selection-modal">
        <div className="modal-header">
          <h3>추천 유입(검색) 키워드 선택 및 수정</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-content">
          <div className="instruction-text">
            <p>*최소 키워드 1개 on해야 주문하기가 가능합니다</p>
            <p>*키워드를 눌러 CPC광고가 나오는 키워드는 해제해주세요.</p>
            <p className="important">
              *{zoomSettings?.allowRanking || 30}위내의 키워드만 ON해주세요.
            </p>
          </div>
          <div className="selection-info">
            <span>선택된 키워드: {selectedCount}/10</span>
          </div>

          <div className="keyword-list">
            <div className="keyword-list-header">
              <div className="header-keyword">키워드</div>
              <div className="header-rank">순위</div>
              <div className="header-status">상태</div>
            </div>

            {localKeywordRanks.map((item, index) => {
              const effectiveAllowRanking = userIsSpecial
                ? Infinity
                : zoomSettings?.allowRanking || 30;

              return (
                <div key={index} className="keyword-list-item">
                  <div className="item-keyword">{item.keyword}</div>
                  <div
                    className={`item-rank ${
                      item.rank > effectiveAllowRanking
                        ? "error"
                        : item.rank === 0
                        ? "empty"
                        : "success"
                    }`}
                  >
                    {item.rank === 999
                      ? "999+위"
                      : item.rank === 0
                      ? "-위"
                      : `${item.rank}위`}
                  </div>
                  <div className="item-status">
                    <label
                      className={`switch ${
                        item.rank > effectiveAllowRanking && !item.selected
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={item.selected}
                        onChange={() => handleToggle(index)}
                        disabled={
                          item.rank > effectiveAllowRanking && !item.selected
                        }
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={handleCancel}>
            취소
          </button>
          <button className="confirm-btn" onClick={handleConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default KeywordSelectionModal;
